import { federatedSessionControllerRevokeCurrentSession } from '../generated/kubb';
import { markFederatedSessionSignedOut } from './federated-session';
import { FEDERATED_REFUSAL_PATH } from './federatedLogin';

/** A revoke that never settles must not keep the broker inside the session. */
const REVOKE_TIMEOUT_MS = 5_000;

/** Revokes the session server-side too, then signs every tab out without logging back in. */
export const signOutFederatedSession = async (): Promise<void> => {
  try {
    await Promise.race([
      federatedSessionControllerRevokeCurrentSession(),
      new Promise(resolve => setTimeout(resolve, REVOKE_TIMEOUT_MS)),
    ]);
  } catch {
    // Already revoked, expired, or offline: leaving is still the right outcome.
  }
  markFederatedSessionSignedOut();
  window.location.replace(`${FEDERATED_REFUSAL_PATH}?reason=signed_out`);
};
